import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../../styles/reset.css';
import '../../styles/root.css';
import '../../styles/global.css';
import '../../styles/main.css';
import { useState } from 'react';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpenMobileMenubar, setIsOpenMobileMenubar] = useState(false);

  const handleClick = (e: { preventDefault: () => void }, target: string) => {
    if (location.pathname === target) {
      e.preventDefault();
      if (target === '/contact') {
        navigate('/contact');
      }

      window.location.reload();
    }
  };

  // 모바일ver. 상단 메뉴 클릭
  const handleMenuClick = (id: string) => {
    // 아코디언: 하나만 열림
    const submenu = $(`#${id}`);

    // 이미 열려있는 경우 → 닫기
    if (submenu.is(':visible')) {
      submenu.slideUp(200);
      submenu.removeClass('active');
    } else {
      // 다른 모든 서브메뉴 닫기
      $('.depth02').slideUp(200);
      $('.depth01 p').removeClass('active');

      // 현재 클릭한 메뉴만 열기
      submenu.slideDown(200);
      submenu.addClass('active');
    }
  };

  // 모바일ver. 서브메뉴 클릭
  const handleSubmenuClick = (e: { preventDefault: () => void }, target: string) => {
    closedBtnClick();

    if (location.pathname === target) {
      e.preventDefault();
      if (target === '/contact') {
        navigate('/contact');
      }

      window.location.reload();
    }
  };

  // 모바일ver. menubar 버튼 클릭
  const hambergerBtnClick = () => {
    const menu = $('#mobilemenu');
    const overlay = $('#overlay');
    setIsOpenMobileMenubar(true);

    menu.toggleClass('active');
    overlay.toggleClass('active');
  };

  // 모바일ver. menubar닫기 버튼 클릭
  const closedBtnClick = () => {
    const menu = $('#mobilemenu');
    const overlay = $('#overlay');
    setIsOpenMobileMenubar(false);

    menu.toggleClass('active');
    overlay.toggleClass('active');

    $('.depth02').slideUp(200);
    $('.depth01 p').removeClass('active');
  };

  // 모바일ver. overlay 영역 클릭
  const overlayClick = () => {
    closedBtnClick();
  };

  return (
    <>
      <header id="header">
        {/* 메인화면 헤더는 backgound-color 화이트로 */}
        <div
          style={{
            backgroundColor: location.pathname === '/' ? 'white' : 'transparent',
          }}
        >
          <div className="m-auto header-flex">
            <div className="flex">
              <div className="header-logo">
                <Link to="/" onClick={(e) => handleClick(e, '/')}>
                  <img src="./images/logo.svg" alt="로고이미지" />
                </Link>
              </div>
              <nav className="header-menu ml-60">
                <ul className="flex">
                  <li>
                    <Link to="/uxbooster" onClick={(e) => handleClick(e, '/uxbooster')}>
                      <span>개발 플랫폼</span>
                    </Link>
                    <div className="depth2">
                      <ul className="sub-menu">
                        <li>
                          <Link to="/uxbooster" onClick={(e) => handleClick(e, '/uxbooster')}>
                            <p className="sub-menu-title">UXBooster</p>
                            <p className="sub-menu-text">
                              기업의 다양한 업무 시스템을 효율적으로 구축할 수 있도록 지원하는 웹
                              기반의 프레임워크
                            </p>
                          </Link>
                        </li>
                        <li>
                          <Link to="/uxboard" onClick={(e) => handleClick(e, '/uxboard')}>
                            <p className="sub-menu-title">UXBoard</p>
                            <p className="sub-menu-text">
                              종합적인 업무관리 및 실적 정보를 한눈에 파악할 수 있는 대시보드 구축
                              서비스
                            </p>
                          </Link>
                        </li>
                        <li>
                          <Link to="/uxcreator" onClick={(e) => handleClick(e, '/uxcreator')}>
                            <p className="sub-menu-title">UXCreator</p>
                            <p className="sub-menu-text">
                              UXBooster를 기본으로 코딩없이 업무화면 · 소스코드를 자동 생성해주는
                              플랫폼
                            </p>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <Link to="/aichanger" onClick={(e) => handleClick(e, '/aichanger')}>
                      <span>서비스</span>
                    </Link>
                    <div className="depth2 service">
                      <ul className="sub-menu">
                        <li>
                          <Link to="/aichanger" onClick={(e) => handleClick(e, '/aichanger')}>
                            <p className="sub-menu-title">웹 전환 서비스 (AIChanger)</p>
                            <p className="sub-menu-text">
                              기존 Client/Server 및 ActiveX 기반 시스템을 HTML5 기반으로 전환해주는
                              자동화 서비스
                            </p>
                          </Link>
                        </li>
                        <li>
                          <Link to="/si" onClick={(e) => handleClick(e, '/si')}>
                            <p className="sub-menu-title">SI 서비스 및 컨설팅</p>
                            <p className="sub-menu-text">
                              고객의 비즈니스 혁신을 실현하는 맞춤형 시스템 통합 서비스
                            </p>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <Link to="/gems" onClick={(e) => handleClick(e, '/gems')}>
                      <span>ESG 솔루션</span>
                    </Link>
                    <div className="depth2 esg">
                      <ul className="sub-menu">
                        <li>
                          <Link to="/gems" onClick={(e) => handleClick(e, '/gems')}>
                            <p className="sub-menu-title">온실가스 관리 솔루션 (GEMS)</p>
                            <p className="sub-menu-text">2050 탄소 중립 실현을 위한 필수 솔루션</p>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <Link to="/epro" onClick={(e) => handleClick(e, '/epro')}>
                      <span>구매/입찰 솔루션</span>
                    </Link>
                    <div className="depth2 epro">
                      <ul className="sub-menu">
                        <li>
                          <Link to="/epro" onClick={(e) => handleClick(e, '/epro')}>
                            <p className="sub-menu-title">전자구매 솔루션 (EPRO)</p>
                            <p className="sub-menu-text">
                              전자구매 업무 프로세스의 시스템화를 위한 e-Procurement 구축에 최적화된
                              EPRO
                            </p>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </nav>
            </div>
            <nav className="header-menu">
              <ul className="flex">
                <li>
                  <Link to="/notice" onClick={(e) => handleClick(e, '/notice')}>
                    <span>고객지원</span>
                  </Link>
                  <div className="depth2">
                    <ul className="sub-menu02">
                      <li>
                        <Link to="/notice" onClick={(e) => handleClick(e, '/notice')}>
                          <p className="sub-menu-title">공지사항</p>
                        </Link>
                      </li>
                      <li>
                        <Link to="/document" onClick={(e) => handleClick(e, '/document')}>
                          <p className="sub-menu-title">자료실</p>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/technical-support"
                          onClick={(e) => handleClick(e, '/technical-support')}
                        >
                          <p className="sub-menu-title">기술지원</p>
                        </Link>
                      </li>
                      <li>
                        <Link to="/contact" onClick={(e) => handleClick(e, '/contact')}>
                          <p className="sub-menu-title">문의하기</p>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="https://939.co.kr/take"
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => handleClick(e, 'https://939.co.kr/take')}
                        >
                          <p className="sub-menu-title">원격지원</p>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <Link to="/intro" onClick={(e) => handleClick(e, '/intro')}>
                    <span>회사소개</span>
                  </Link>
                  <div className="depth2">
                    <ul className="sub-menu02">
                      <li>
                        <Link to="/intro" onClick={(e) => handleClick(e, '/intro')}>
                          <p className="sub-menu-title">회사개요</p>
                        </Link>
                      </li>
                      <li>
                        <Link to="/ci" onClick={(e) => handleClick(e, '/ci')}>
                          <p className="sub-menu-title">CI</p>
                        </Link>
                      </li>
                      <li>
                        <Link to="/license" onClick={(e) => handleClick(e, '/license')}>
                          <p className="sub-menu-title">특허 및 인증</p>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
      {/* 모바일 헤더 */}
      <div className="mobile">
        <div
          style={{
            backgroundColor: location.pathname === '/' ? 'white' : 'transparent',
          }}
        >
          <div className="mobile-header px-20">
            <div className="mobile-header-logo">
              <Link to="/" onClick={(e) => handleClick(e, '/')}>
                <img src="./images/logo.svg" alt="메인페이지로" />
              </Link>
            </div>
            <button className="hamburger" id="hamburger">
              {isOpenMobileMenubar ? (
                <img src="./images/ico-close.svg" alt="메뉴닫기" onClick={closedBtnClick} />
              ) : (
                <img src="./images/ico-hamburger.svg" alt="메뉴열기" onClick={hambergerBtnClick} />
              )}
            </button>
          </div>
        </div>
      </div>
      <div id="overlay" className="background-dimmed" onClick={overlayClick}></div>
      <div className="mobile-menu" id="mobilemenu">
        <ul>
          <li className="depth01" id="menu01">
            <p onClick={(e) => handleMenuClick('subMenu01')}>개발 플랫폼</p>
            <ul className="depth02" id="subMenu01">
              <li>
                <Link to="/uxbooster" onClick={(e) => handleSubmenuClick(e, '/uxbooster')}>
                  UXBooster
                </Link>
              </li>
              <li>
                <Link to="/uxboard" onClick={(e) => handleSubmenuClick(e, '/uxboard')}>
                  UXBoard
                </Link>
              </li>
              <li>
                <Link to="/uxcreator" onClick={(e) => handleSubmenuClick(e, '/uxcreator')}>
                  UXCreator
                </Link>
              </li>
            </ul>
          </li>
          <li className="depth01" id="menu02">
            <p onClick={(e) => handleMenuClick('subMenu02')}>서비스</p>
            <ul className="depth02" id="subMenu02">
              <li>
                <Link to="/aichanger" onClick={(e) => handleSubmenuClick(e, '/aichanger')}>
                  AIChanger
                </Link>
              </li>
              <li>
                <Link to="/si" onClick={(e) => handleSubmenuClick(e, '/si')}>
                  SI 서비스 및 컨설팅
                </Link>
              </li>
            </ul>
          </li>
          <li className="depth01" id="menu03">
            <p onClick={(e) => handleMenuClick('subMenu03')}>ESG 솔루션</p>
            <ul className="depth02" id="subMenu03">
              <li>
                <Link to="/gems" onClick={(e) => handleSubmenuClick(e, '/gems')}>
                  GEMS
                </Link>
              </li>
            </ul>
          </li>
          <li className="depth01" id="menu04">
            <p onClick={(e) => handleMenuClick('subMenu04')}>구매/입찰 솔루션</p>
            <ul className="depth02" id="subMenu04">
              <li>
                <Link to="/epro" onClick={(e) => handleSubmenuClick(e, '/epro')}>
                  EPRO
                </Link>
              </li>
            </ul>
          </li>
          <li className="depth01" id="menu05">
            <p onClick={(e) => handleMenuClick('subMenu05')}>고객지원</p>
            <ul className="depth02" id="subMenu05">
              <li>
                <Link to="/notice" onClick={(e) => handleSubmenuClick(e, '/notice')}>
                  공지사항
                </Link>
              </li>
              <li>
                <Link to="/document" onClick={(e) => handleSubmenuClick(e, '/document')}>
                  자료실
                </Link>
              </li>
              <li>
                <Link
                  to="/technical-support"
                  onClick={(e) => handleSubmenuClick(e, '/technical-support')}
                >
                  기술지원
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={(e) => handleSubmenuClick(e, '/contact')}>
                  문의하기
                </Link>
              </li>
            </ul>
          </li>
          <li className="depth01" id="menu06">
            <p onClick={(e) => handleMenuClick('subMenu06')}>회사소개</p>
            <ul className="depth02" id="subMenu06">
              <li>
                <Link to="/intro" onClick={(e) => handleSubmenuClick(e, '/intro')}>
                  회사개요
                </Link>
              </li>
              <li>
                <Link to="/ci" onClick={(e) => handleSubmenuClick(e, '/ci')}>
                  CI
                </Link>
              </li>
              <li>
                <Link to="/license" onClick={(e) => handleSubmenuClick(e, '/license')}>
                  특허 및 인증
                </Link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Header;
